import { useEffect } from 'react';
import { resolveMobilityConfig } from '../config/mobility-buttons';
import {
  getAllowedAdminOrigin,
  isInIframe,
  isValidPreviewMessage,
} from '../config/mobility-preview';

const ALLOWED_ADMIN_ORIGIN = getAllowedAdminOrigin();

/**
 * Listens for admin postMessage preview updates (iframe mode only).
 */
export function useMobilityPreviewListener({ previewReceivedRef, onPreviewConfig }) {
  useEffect(() => {
    if (!isInIframe()) return;

    function handlePreviewMessage(event) {
      if (event.origin !== ALLOWED_ADMIN_ORIGIN) return;
      if (!isValidPreviewMessage(event.data)) return;

      previewReceivedRef.current = true;
      onPreviewConfig(resolveMobilityConfig(event.data.config));
    }

    window.addEventListener('message', handlePreviewMessage);
    return () => window.removeEventListener('message', handlePreviewMessage);
  }, [previewReceivedRef, onPreviewConfig]);
}
